<template>
  <Teleport to="body">
    <Transition name="toast">
      <div
        v-if="visible"
        class="app-toast"
        role="status"
        aria-live="polite"
        @click="hide"
      >
        <i class="fas fa-info-circle"></i>
        <span class="app-toast-text">{{ message }}</span>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
import { useToast } from '@/composables/useToast'

const { message, visible, hide } = useToast()
</script>

<style scoped>
.app-toast {
  position: fixed;
  bottom: 2.5rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.85rem 1.5rem;
  background: rgba(20, 20, 20, 0.92);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 999px;
  color: #fff;
  font-size: 0.95rem;
  z-index: 2000;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.35);
  cursor: pointer;
  max-width: calc(100vw - 2rem);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.app-toast i {
  color: #00c6ff;
  font-size: 1.1rem;
  flex-shrink: 0;
}

.app-toast-text {
  overflow: hidden;
  text-overflow: ellipsis;
}

.toast-enter-active,
.toast-leave-active {
  transition: opacity 0.3s ease, transform 0.3s cubic-bezier(0.22, 1, 0.36, 1);
}

.toast-enter-from {
  opacity: 0;
  transform: translate(-50%, 20px);
}

.toast-leave-to {
  opacity: 0;
  transform: translate(-50%, 12px);
}

@media (max-width: 480px) {
  .app-toast {
    font-size: 0.875rem;
    padding: 0.75rem 1.25rem;
    bottom: 1.75rem;
  }
}
</style>
